module.exports = __webpack_public_path__ + "img/studio-2.927b288c.jpg";